export const BOOKINGS_STATUS = 'BOOKINGS_STATUS'
export const BOOKINGS_CUSTOMER_NAME = 'BOOKINGS_CUSTOMER_NAME'
export const BOOKINGS_POSTAL_CODE = 'BOOKINGS_POSTAL_CODE'
export const BOOKINGS_START_DATE = 'BOOKINGS_START_DATE'
export const BOOKINGS_END_DATE = 'BOOKINGS_END_DATE'
export const RESET_FILTERS = 'RESET_FILTERS'
export const PAGE_SIZE = 'PAGE_SIZE'
export const PAGE_NUMBER = 'PAGE_NUMBER'
export const REGION_CHANGE = 'REGION_CHANGE'
export const REFERENCE_ID = 'REFERENCE_ID'

// New action types
export const BOOKINGS_ASSIGNED_COLLECTOR = 'BOOKINGS_ASSIGNED_COLLECTOR'
export const BOOKINGS_PREFERRED_COLLECTOR = 'BOOKINGS_PREFERRED_COLLECTOR'
export const BOOKINGS_CREATED_BY = 'BOOKINGS_CREATED_BY'
export const BOOKINGS_ASSIGNED_BY = 'BOOKINGS_ASSIGNED_BY'
export const BOOKINGS_VENUE_STATE = 'BOOKINGS_STATE'
